import Ripple from 'styles/components/loader';

export default function Loader({ className }) {
    return <Ripple className={className}>
        <span aria-hidden='true' />
        <span aria-hidden='true' />
    </Ripple>;
}
